import React from 'react';
import { Link } from 'react-router-dom';
var selfStyles = require('./HeaderItemBrand.scss');
var crimpLogo = require('src/assets/logo/favicon-64.png');
var HeaderItemBrand = function () { return (React.createElement("div", { className: selfStyles.brand },
    React.createElement(Link, { to: '/welcome' },
        React.createElement("img", { src: crimpLogo, className: selfStyles.brandLogo, alt: 'CRIMP' })),
    React.createElement(Link, { to: '/welcome', className: selfStyles.brandName },
        process.env.REACT_APP_DEPLOY_ENV === 'staging'
            ? 'PINCH'
            : process.env.REACT_APP_DEPLOY_ENV === 'production'
                ? 'CRIMP'
                : 'CRIMP.',
        process.env.NODE_ENV === 'development' && React.createElement("small", null, "dev")))); };
export default HeaderItemBrand;



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageHeader/HeaderItemBrand.tsx
// module id = 753
// module chunks = 0